import script from "./CoreServiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreServiceView.vue?vue&type=script&setup=true&lang=js"

import "./CoreServiceView.vue?vue&type=style&index=0&id=a022e67a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a022e67a"]])

export default __exports__